import { Pipe, PipeTransform } from '@angular/core';
import {
	ICommonActionsDropdownComponentAction
} from '@CaseOne/Common/context-menu/actions-dropdown.component/common-actions-dropdown.interfaces';
import { isFunction } from 'lodash';

@Pipe({
	name: 'commonActionsDropdownOptionName',
})
export class CommonActionsDropdownOptionNamePipe<EntityType> implements PipeTransform {
	transform(
		action: ICommonActionsDropdownComponentAction<EntityType>,
		entity: EntityType,
	): string {
		return isFunction(action.name)
			? action.name(entity)
			: action.name;
	}
}
